export function backToTop(lenis, root = document) {
    root.querySelectorAll('[data-back-to-top]').forEach((link) => {
        link.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

            event.preventDefault();
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            lenis.scrollTo(0, {
                immediate: reducedMotion,
                onComplete: () => {
                    // Move keyboard focus with the viewport, without another scroll.
                    const body = document.body;
                    const tabindex = body.getAttribute('tabindex');
                    body.setAttribute('tabindex', '-1');
                    body.focus({ preventScroll: true });
                    if (tabindex === null) {
                        body.removeAttribute('tabindex');
                    } else {
                        body.setAttribute('tabindex', tabindex);
                    }
                },
            });
        });
    });
}
